import styled from "styled-components";
import { ParcelCol } from "styles/parcelsStyles";

export const OutgoingCol = styled(ParcelCol)`
  &:nth-child(1) {
    word-break: normal;
  }

  ${(props) => props.theme.xs`
    &:nth-child(4) {
      justify-content: flex-start;
      text-align: start;
    }
  `}
`;

export const WeightAndPrice = styled.div`
  font-weight: 700;
  color: black;
`;
